import styled from 'styled-components';
import { COLORS, FONT_SIZES, FONT_WEIGHTS } from '@/theme';

export const StyledMenuItemWithBadge = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 0.5rem;
`;

export const StyledMenuItemLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledMenuNotificationBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 1.375rem;
  height: 1.375rem;
  padding: 0 0.4375rem;
  margin-left: auto;
  border-radius: 0.6875rem;
  background-color: ${COLORS.RED};
  color: ${COLORS.WHITE};
  font-size: ${FONT_SIZES['10']};
  font-weight: ${FONT_WEIGHTS.SEMI_BOLD};
  line-height: 1;
  letter-spacing: 0.01em;
  box-shadow: 0 1px 4px rgba(213, 58, 58, 0.4);
`;
